import { Button, Grid2, Typography, Box, useMediaQuery } from "@mui/material";
import React, { useState, useCallback, useEffect } from "react";
import axios from 'axios';


export default function SubmissionDetails({organization, subType, fileName, email, onCloseSub}) {
    const serverHost = process.env.REACT_APP_BACKEND_SERVER_HOST || 'https://localhost:3001';
    const [submissionDetail, setSubmissionDetail] = useState("");

      const fetchSubmissionDetails = useCallback(async () => {
        try {
          const fileNameEscaped = encodeURIComponent(fileName);
          const response = await axios.get(`${serverHost}/submissions/${email}/${fileNameEscaped}/details`, { withCredentials: true });
          if (response.status === 200) {
              setSubmissionDetail(response.data.details);
          }
        } catch (error) {
          console.error('Error fetching submissions:', error.response ? error.response.data : error.message);
        }
      }, [serverHost, email, fileName]);

    const matches = useMediaQuery('(max-width:600px)');

    const changeTrack = {
        'dataset': 'Dataset',
        'track1':  'Document Validation',
        'track2':  'Match to ID',
        'track3':  'Passive PAD'
      }

      const changeTypeName = (typeName) => {
        return changeTrack[typeName] || typeName; 
       }

      useEffect(() => {
          fetchSubmissionDetails();
        }, [fetchSubmissionDetails]);

    return(
            <Box className="modal-container">
                <Box className="modal-box1">
                    <Typography className="modal-header">SUBMISSION DETAILS</Typography>
                    <Grid2 container spacing={2} rowSpacing={0} sx={{marginTop: '10px'}} className="submission-display-flex">
                        <Grid2 item size={3}>
                            <Typography className="modal-sub-header">Organization</Typography>
                        </Grid2>
                        <Grid2 item size={3}>
                            <Typography className="modal-sub-header">Submission Type</Typography>
                        </Grid2>
                        <Grid2 item size={3}>
                            <Typography className="modal-sub-header">File Name</Typography>
                        </Grid2>
                        <Grid2 item size={3} />
                        <Grid2 item size={3}>
                            <Typography className="modal-description">{organization}</Typography>
                        </Grid2>
                        <Grid2 item size={3}>
                            <Typography className="modal-description">{changeTypeName(subType)}</Typography>
                        </Grid2>
                        <Grid2 item size={6}>
                            <Typography className="modal-description">{fileName.split('/').reverse()[0]}</Typography>
                        </Grid2>
                    </Grid2>
                    <Grid2 container spacing={2} rowSpacing={0} sx={{marginTop: '10px'}} className="submission-display-block">
                        <Grid2 item size={12}>
                            <Typography className="modal-sub-header">Organization</Typography>
                        </Grid2>
                        <Grid2 item size={12} sx={{marginBottom: '10px'}}>
                            <Typography className="modal-description">{organization}</Typography>
                        </Grid2>
                        <Grid2 item size={12}>
                            <Typography className="modal-sub-header">Submission Type</Typography>
                        </Grid2>
                        <Grid2 item size={12} sx={{marginBottom: '10px'}}>
                            <Typography className="modal-description">{changeTypeName(subType)}</Typography>
                        </Grid2>
                        <Grid2 item size={12}>
                            <Typography className="modal-sub-header">File Name</Typography>
                        </Grid2>
                        <Grid2 item size={12}>
                            <Typography className="modal-description">{fileName.split('/').reverse()[0]}</Typography>
                        </Grid2>
                    </Grid2>
                </Box>
                <Box className="modal-box2">
                    <Typography className="modal-sub-header">Submission History</Typography>
                    <Box className='modal-submission-history1'>
                        <Typography className="submission-history-text">
                            {submissionDetail}
                        </Typography>
                    </Box>
                    <Button onClick={onCloseSub} sx={{width: matches ? '50%' : '100%', marginTop: '30px'}} variant="oulined">CLOSE</Button>
                </Box>
            </Box>
    )
}